/*!

=========================================================
* DealerClick 2.0 - v1.0
=========================================================

* Product Page: https://dealerclick.com
* Copyright 2020 RoarinLion (https://dealerclick.com)

* Coded by DealerClick Software ))

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
import NavBar from "components/tabs/TabsHolder";
import FormsReportsList from "../forms/components/FormsReportsList";
import { useFromLocations, useFromUser } from "stores/LocalStorageHelper";
import { Col } from "reactstrap";
import { TemplateVariableProvider } from "../../context/TemplateVariableContext";
import useIsOwnerOrAdmin from "../settings/subFeatures/settingsTabs/userManagement/useIsOwnerOrAdmin";
import UnauthorizedContent from "../deal/subFeatures/dealTabs/tabsContainer/UnauthorizedContent";
import { useUserBhphPrivileges } from "../settings/subFeatures/settingsTabs/userManagement/useUserPrivileges";

const ReportsPage = () => {
	const locationID = useFromUser("locationID");
	let hasBhph = 0;
	let hasLhph = 0;
	let hasRto = 0;
	hasBhph = useFromLocations("fn");
	hasLhph = useFromLocations("ls");
	hasRto = useFromLocations("nls");
	const state = useFromLocations("state");
	const isOwnerOrAdmin = useIsOwnerOrAdmin();
	const tabs = ["Inventory", "Management", "Sales", "Requested"];
	const privileges = useUserBhphPrivileges();
	const p = privileges();
	const accessGeneralReports = p.accessGeneralReports;
	// if (hasBhph === 1 && accessGeneralReports) tabs.push("BHPH");
	// if (hasBhph === 1 && hasLhph === 1 && accessGeneralReports) tabs.push("LHPH");
	// if (hasBhph === 1 && hasRto === 1 && accessGeneralReports) tabs.push("RTO");
	if ((hasBhph === 1 || hasLhph === 1 || hasRto === 1) && accessGeneralReports)
		tabs.push("Accounts");
	if (state === "TX") tabs.push("XLS");

	// if ([4757, 6730, 7942, 5456, 7906, 7464, 7664, 4575].includes(locationID)) {
	// 	bhph = 1;
	// 	tabs.push("BHPH");
	// } else {
	// 	bhph = 0;
	// }

	const tabComponents = [
		<>
			{(accessGeneralReports && (
				<FormsReportsList
					listTitle="Inventory Reports"
					searchable={true}
					listName={"inventoryReports"}
				/>
			)) || <UnauthorizedContent />}
		</>,
		isOwnerOrAdmin ? (
			<FormsReportsList
				listTitle="Management Reports"
				searchable={true}
				listName={"managementReports"}
			/>
		) : (
			<UnauthorizedContent />
		),
		<FormsReportsList
			listTitle="Sales Reports"
			searchable={true}
			listName={"salesReports"}
		/>,
		<FormsReportsList
			listTitle="Requested Reports"
			searchable={true}
			listName={"customReports"}
		/>,
		<>
			{((hasBhph === 1 || hasLhph === 1 || hasRto === 1) &&
				accessGeneralReports && (
					<FormsReportsList
						listTitle="BHPH Reports"
						searchable={true}
						listName={"bhphReports"}
					/>
				)) ||
				null}
		</>,
		// <>
		// 	{(hasBhph === 1 && hasLhph === 1 && accessGeneralReports && (
		// 		<FormsReportsList
		// 			listTitle="LHPH Reports"
		// 			searchable={true}
		// 			listName={"lhphReports"}
		// 		/>
		// 	)) ||
		// 		null}
		// </>,
		// <>
		// 	{(hasBhph === 1 && hasRto === 1 && accessGeneralReports && (
		// 		<FormsReportsList
		// 			listTitle="RTO Reports"
		// 			searchable={true}
		// 			listName={"rtoReports"}
		// 		/>
		// 	)) ||
		// 		null}
		// </>,
		<>
			{(state === "TX" && (
				<FormsReportsList
					listTitle="XLS Reports"
					searchable={true}
					listName={"xlsReports"}
					isXls={true}
				/>
			)) ||
				null}
		</>,
	];
	return (
		<TemplateVariableProvider>
			{/*No template variable initializer needed */}
			<div className="mx-0 content justify-content-center align-items-center">
				<Col>
					<NavBar
						navClass="nav-pills nav-pills-primary justify-content-center nav"
						tabs={tabs}
						tabComponents={tabComponents}
					/>
				</Col>
			</div>
		</TemplateVariableProvider>
	);
};
export default ReportsPage;
